const initialState = {
	loading: false,
	errors: null,
	uploadId: null,
	uploadProgress: -1,
};

export default initialState;
